import React from "react";
import { TiPointOfInterest } from "react-icons/ti";
import { Link } from "react-router-dom";
import { AiOutlineCaretRight } from "react-icons/ai";
import { LazyLoadImage } from "react-lazy-load-image-component";

const DoctorCard = ({
  doc,
  main,
  name,
  edu,
  spe,
  exp,
  desc1,
  desc2,
  highlight,
  sp1,
  sp2,
  sp3,
  setSingleDoc,
  adSub,
  adLoc,
}) => {
  return (
    <div className="subDoc">
      <LazyLoadImage effect="blur" src={doc} alt="" />
      <div className="details">
        <div>
          <h2 className="name">{name}</h2>
          <p className="frow">
            {" "}
            <TiPointOfInterest className="point" /> <span>{edu}</span>
          </p>
          <p className="srow">
            <TiPointOfInterest className="point" />
            <span>{spe}</span>
          </p>

          <Link
            to={main ? "/chief-specialist" : "/related-specialist"}
            className="docDet"
            onClick={() =>
              setSingleDoc({
                name,
                edu,
                spe,
                doc,
                exp,
                desc1,
                desc2,
                highlight,
                sp1,
                sp2,
                sp3,
                adSub,
                adLoc,
              })
            }
          >
            Details <AiOutlineCaretRight className="ico" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DoctorCard;
